<script setup>
import { computed, watch } from 'vue'

const props = defineProps({
  show: { type: Boolean, default: false },
  size: { type: String, default: '' },
  duration: { type: Number, default: 1500 },
  message: { type: String, default: '' },
  teleport: { type: String, default: 'body' },
  teleportDis: { type: Boolean, default: false },
  transition: { type: String, default: 'tvb-fade' },
  position: { type: String, default: 'fixed' },
  classNmae: { type: String, default: '' }
})

const emit = defineEmits(['update:show'])

let timer = null
const clearTimer = () => clearTimeout(timer)
const updateShow = (value) => emit('update:show', value)
const positionStyle = computed(() => `position: ${props.position}`)

watch(
  () => [props.show],
  () => {
    clearTimer()
    if (props.show && props.duration > 0) {
      timer = setTimeout(() => {
        updateShow(false)
      }, props.duration)
    }
  }
)
</script>

<template>
  <teleport :to="teleport" :disabled="teleportDis">
    <transition :name="transition">
      <div
        v-show="show"
        class="tvb-toast"
        :class="[size ? size : '', classNmae]"
        :style="positionStyle"
      >
        <span class="tvb-toast--text">{{ message }}</span>
      </div>
    </transition>
  </teleport>
</template>

<style lang="scss" scoped>
.tvb-toast {
  --tvb-toast-max-width: 70%;
  --tvb-toast-font-size: 16px;
  --tvb-toast-text-color: rgba(255, 255, 255, 0.9);
  --tvb-toast-line-height: 26px;
  --tvb-toast-radius: 8px;
  --tvb-toast-background: rgba(0, 0, 0, 0.7);
  --tvb-toast-text-min-width: 103px;
  --tvb-toast-default-padding: 6px 10px;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  // box-sizing: content-box;

  min-width: var(--tvb-toast-text-min-width);
  max-width: var(--tvb-toast-max-width);
  padding: var(--tvb-toast-default-padding);
  color: var(--tvb-toast-text-color);
  font-size: var(--tvb-toast-font-size);
  line-height: var(--tvb-toast-line-height);
  letter-spacing: 0.5px;
  white-space: pre-wrap;
  word-break: break-all;
  text-align: center;
  background: var(--tvb-toast-background);
  border-radius: var(--tvb-toast-radius);
  backdrop-filter: blur(10px);

  &.s,
  &.xs {
    --tvb-toast-radius: 6px;
  }
}
</style>
